import { t } from 'src/i18n';
import { DayOfWeek } from 'src/utilities/local-date.js';
import type { WeekdayStr } from './weekdayStr';

export const Days: {
  MO: WeekdayStr;
  TU: WeekdayStr;
  WE: WeekdayStr;
  TH: WeekdayStr;
  FR: WeekdayStr;
  SA: WeekdayStr;
  SU: WeekdayStr;
} = {
  MO: 'MO',
  TU: 'TU',
  WE: 'WE',
  TH: 'TH',
  FR: 'FR',
  SA: 'SA',
  SU: 'SU',
};

export const DayOfWeekLookup: {
  MO: DayOfWeek;
  TU: DayOfWeek;
  WE: DayOfWeek;
  TH: DayOfWeek;
  FR: DayOfWeek;
  SA: DayOfWeek;
  SU: DayOfWeek;
} = {
  MO: DayOfWeek.MONDAY,
  TU: DayOfWeek.TUESDAY,
  WE: DayOfWeek.WEDNESDAY,
  TH: DayOfWeek.THURSDAY,
  FR: DayOfWeek.FRIDAY,
  SA: DayOfWeek.SATURDAY,
  SU: DayOfWeek.SUNDAY,
};

export function toDayOfWeek(weekday: WeekdayStr): DayOfWeek {
  return DayOfWeekLookup[weekday];
}

// Bygges lazy inne i funksjonen slik at i18n-`t()` kjøres ved kalltid, ikke import.
export function getWeekdayName(weekday: DayOfWeek): string {
  const dayOfWeekNameLookup: Map<DayOfWeek, string> = new Map<DayOfWeek, string>([
    [DayOfWeek.MONDAY, t('recurrence.weekdays.monday')],
    [DayOfWeek.TUESDAY, t('recurrence.weekdays.tuesday')],
    [DayOfWeek.WEDNESDAY, t('recurrence.weekdays.wednesday')],
    [DayOfWeek.THURSDAY, t('recurrence.weekdays.thursday')],
    [DayOfWeek.FRIDAY, t('recurrence.weekdays.friday')],
    [DayOfWeek.SATURDAY, t('recurrence.weekdays.saturday')],
    [DayOfWeek.SUNDAY, t('recurrence.weekdays.sunday')],
  ]);
  const value = dayOfWeekNameLookup.get(weekday);
  if (value !== undefined) {
    return value;
  } else {
    throw new Error('Illegal state (E801), weekday not found ' + weekday);
  }
}

export function getMonthName(month: number): string {
  const monthNameLookup = [
    t('recurrence.months.january'),
    t('recurrence.months.february'),
    t('recurrence.months.march'),
    t('recurrence.months.april'),
    t('recurrence.months.may'),
    t('recurrence.months.june'),
    t('recurrence.months.july'),
    t('recurrence.months.august'),
    t('recurrence.months.september'),
    t('recurrence.months.october'),
    t('recurrence.months.november'),
    t('recurrence.months.december'),
  ];
  const value = monthNameLookup[month - 1];
  if (value !== undefined) {
    return value;
  } else {
    throw new Error('Illegal state (E802), month out of range ' + month);
  }
}

export function toOrdinal(index: number): string {
  const ordinals = [
    t('recurrence.ordinals.first'),
    t('recurrence.ordinals.second'),
    t('recurrence.ordinals.third'),
    t('recurrence.ordinals.fourth'),
    t('recurrence.ordinals.fifth'),
    t('recurrence.ordinals.sixth'),
  ];
  if (index === -1) {
    return t('recurrence.ordinals.last');
  } else {
    return ordinals[index - 1];
  }
}
